import React, { useEffect } from 'react';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      maxWidth: '900px',
      margin: '40px auto',
      padding: '0 20px',
      lineHeight: '1.8',
      color: '#333',
      textAlign: 'left'
    }}>
      <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>Privacy Policy</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Last updated: {new Date().toLocaleDateString()}</p>
      
      <div style={{ fontSize: '15px', textAlign: 'left' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>1. Introduction</h2>
          <p style={{ marginBottom: '15px' }}>
            Welcome to Bokeh ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website 
            <a href="https://bokehclo.com" style={{ color: '#000', textDecoration: 'underline', margin: '0 4px' }}>https://bokehclo.com</a> 
            and make purchases from our online store.
          </p>
          <p style={{ marginBottom: '15px' }}>
            Please read this Privacy Policy carefully. By using our website, you agree to the collection and use of information 
            in accordance with this policy. If you do not agree with our policies and practices, please do not use our website.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>2. Information We Collect</h2>
          <p style={{ marginBottom: '15px' }}>
            We collect information that you provide directly to us when you:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Make a purchase or place an order</li>
            <li>Create an account (admin users only)</li>
            <li>Contact us with inquiries</li>
            <li>Subscribe to our newsletter or promotional emails</li>
            <li>Interact with our website</li>
          </ul>
          
          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Personal Information</h3>
          <p style={{ marginBottom: '15px' }}>
            The types of personal information we may collect include:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li><strong>Contact Information:</strong> Name, email address, phone number</li>
            <li><strong>Shipping Information:</strong> Delivery address, billing address</li>
            <li><strong>Payment Information:</strong> Credit card details, billing information (processed securely through third-party payment processors)</li>
            <li><strong>Order Information:</strong> Products purchased, order history, preferences</li>
          </ul>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Automatically Collected Information</h3>
          <p style={{ marginBottom: '15px' }}>
            When you visit our website, we automatically collect certain information about your device and browsing actions, including:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>IP address and device identifiers</li>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>Pages visited and time spent on pages</li>
            <li>Referring website addresses</li>
            <li>Click data and browsing behavior</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>3. How We Use Your Information</h2>
          <p style={{ marginBottom: '15px' }}>
            We use the information we collect for the following purposes:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li><strong>Order Processing:</strong> To process and fulfill your orders, including shipping and delivery</li>
            <li><strong>Payment Processing:</strong> To process payments securely through our payment providers</li>
            <li><strong>Customer Service:</strong> To respond to your inquiries, provide customer support, and handle returns or exchanges</li>
            <li><strong>Communications:</strong> To send order confirmations, shipping updates, and administrative information</li>
            <li><strong>Marketing:</strong> To send promotional emails about new products, special offers, and updates (with your consent)</li>
            <li><strong>Analytics:</strong> To understand how visitors use our website and improve user experience</li>
            <li><strong>Security:</strong> To protect against fraud, unauthorized transactions, and other illegal activities</li>
            <li><strong>Legal Compliance:</strong> To comply with applicable laws and regulations</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>4. Third-Party Services</h2>
          <p style={{ marginBottom: '15px' }}>
            We work with trusted third-party service providers to operate our business. These providers have access to your 
            personal information only to perform specific tasks on our behalf and are obligated to protect your information.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Payment Processing</h3>
          <p style={{ marginBottom: '15px' }}>
            We use <strong>Stripe</strong> and <strong>PayPal</strong> to process payments. Your payment information is transmitted 
            directly to these payment processors and is not stored on our servers. These services have their own privacy policies:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Stripe Privacy Policy: <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#000', textDecoration: 'underline' }}>https://stripe.com/privacy</a></li>
            <li>PayPal Privacy Policy: <a href="https://www.paypal.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#000', textDecoration: 'underline' }}>https://www.paypal.com/privacy</a></li>
          </ul>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Shipping</h3>
          <p style={{ marginBottom: '15px' }}>
            We use <strong>Shippo</strong> to calculate shipping rates and generate shipping labels. Your shipping information 
            is shared with Shippo and the selected shipping carrier to fulfill your order.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Analytics</h3>
          <p style={{ marginBottom: '15px' }}>
            We use <strong>Google Analytics</strong> to understand how visitors interact with our website. Google Analytics collects 
            information such as how often users visit our site, what pages they visit, and what other sites they used prior to coming to our site. 
            Learn more about Google's privacy practices at: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#000', textDecoration: 'underline' }}>https://policies.google.com/privacy</a>
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>5. Cookies and Tracking Technologies</h2>
          <p style={{ marginBottom: '15px' }}>
            We use cookies and similar tracking technologies to track activity on our website and store certain information. 
            Cookies are small data files stored on your device. We use the following types of cookies:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li><strong>Essential Cookies:</strong> Required for the website to function properly (e.g., shopping cart functionality)</li>
            <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our website (Google Analytics)</li>
            <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not 
            accept cookies, you may not be able to use some portions of our website.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>6. Data Security</h2>
          <p style={{ marginBottom: '15px' }}>
            We take the security of your personal information seriously and implement appropriate technical and organizational measures to protect it:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Secure Socket Layer (SSL) encryption for data transmission</li>
            <li>Secure payment processing through PCI-compliant providers</li>
            <li>Password protection for admin accounts with encrypted password storage</li>
            <li>Regular security updates and monitoring</li>
            <li>Limited access to personal information by authorized personnel only</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            However, please note that no method of transmission over the Internet or electronic storage is 100% secure. 
            While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee absolute security.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>7. Data Retention</h2>
          <p style={{ marginBottom: '15px' }}>
            We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, 
            including:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>To provide our services and complete transactions</li>
            <li>To comply with legal, tax, and accounting obligations</li>
            <li>To resolve disputes and enforce our agreements</li>
            <li>For business recordkeeping purposes</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            Order information is typically retained for 7 years to comply with tax and accounting regulations. 
            Marketing data is retained until you unsubscribe or request deletion.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>8. Your Privacy Rights</h2>
          <p style={{ marginBottom: '15px' }}>
            Depending on your location, you may have certain rights regarding your personal information:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
            <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
            <li><strong>Deletion:</strong> Request deletion of your personal information (subject to legal obligations)</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from marketing emails at any time</li>
            <li><strong>Data Portability:</strong> Request transfer of your data to another service</li>
            <li><strong>Objection:</strong> Object to processing of your personal information for marketing purposes</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            To exercise any of these rights, please contact us using the information provided below. We will respond to your request within 30 days.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>9. Children's Privacy</h2>
          <p style={{ marginBottom: '15px' }}>
            Our website is not intended for children under the age of 13. We do not knowingly collect personal information from 
            children under 13. If you are a parent or guardian and believe your child has provided us with personal information, 
            please contact us immediately so we can delete such information.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>10. International Data Transfers</h2>
          <p style={{ marginBottom: '15px' }}>
            Your information may be transferred to and maintained on computers located outside of your state, province, country, 
            or other governmental jurisdiction where data protection laws may differ. By using our website and providing your information, 
            you consent to such transfers.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>11. Changes to This Privacy Policy</h2>
          <p style={{ marginBottom: '15px' }}>
            We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, 
            legal, or regulatory reasons. We will notify you of any material changes by posting the new Privacy Policy on this page 
            and updating the "Last updated" date at the top.
          </p>
          <p style={{ marginBottom: '15px' }}>
            We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>12. Contact Us</h2>
          <p style={{ marginBottom: '15px' }}>
            If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:
          </p>
          <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', marginTop: '15px' }}>
            <p style={{ marginBottom: '8px' }}><strong>Bokeh</strong></p>
            <p style={{ marginBottom: '8px' }}>Email: <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a></p>
            <p style={{ marginBottom: '8px' }}>Website: <a href="https://bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>https://bokehclo.com</a></p>
          </div>
        </section>

        <section style={{ marginBottom: '30px', marginTop: '40px', padding: '20px', background: '#f0f0f0', borderRadius: '5px' }}>
          <p style={{ fontSize: '13px', color: '#666', fontStyle: 'italic', marginBottom: '0' }}>
            <strong>Disclaimer:</strong> This Privacy Policy is provided as a general template and may not cover all legal requirements 
            for your specific jurisdiction or business situation. For complete legal compliance, we recommend consulting with a qualified 
            attorney who specializes in privacy law.
          </p>
        </section>
      </div>
    </div>
  );
}

